import {ConnectedComponent,sharedComponent} from 'lowkey-component'

import {sleep} from '@lib/utils'
import {createApplicationState} from '@services/ApplicationState'
import {IApplicationState} from '@services/types'
import {appSelectors} from '@store/appSlice'

@sharedComponent
export class PageIndicator extends ConnectedComponent<HTMLDivElement> {
  private appState: IApplicationState = createApplicationState()
  private logo: HTMLDivElement | undefined | null

  didMount() {
    this.logo = this.element.querySelector<HTMLDivElement>('.o-page-indicator_logo')
    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'show') {
        this.appState.updatePageIndicatorStatus('startShowAnimation')
        this.start()
        await sleep(1000)
        this.appState.updatePageIndicatorStatus('endShowAnimation')
      } else if (status === 'hide') {
        this.appState.updatePageIndicatorStatus('startHideAnimation')
        this.end()
        await sleep(200)
        this.appState.updatePageIndicatorStatus('hidingAnimation')
        await sleep(700)
        this.appState.updatePageIndicatorStatus('endHideAnimation')
      }
    })
  }

  start() {
    this.element.classList.remove('shrink')
    this.element.classList.add('expand')
  }

  end() {
    this.element.classList.remove('expand')
    this.element.classList.add('shrink')
  }
}
